import React, { useEffect, useState } from 'react';
import {Typography, Box, CircularProgress} from '@mui/material';
import { useParams } from 'react-router-dom';
import { getContest } from '../api/contests';
import DiscussionsButton from '../utils/DiscussionsButton';

interface Contest {
  contest_id: number;
  name: string;
  description: string;
  intro_url?: string | null;
}

const RulesView: React.FC = () => {
  const { contestId } = useParams<{ contestId: string }>();
  const [contest, setContest] = useState<Contest | null>(null);

  useEffect(() => {
    if(!contestId)
      return;
    getContest(contestId).then((data) => {
      setContest(data || null);
    });
  }, [contestId]);

  if (!contest) {
    return   <Box display="flex" justifyContent="center" mt={2}>
      <CircularProgress />
    </Box>
  }

  return (
    <Box style={{marginTop:10}}>
      <Typography variant="h6" gutterBottom color="primary">
        Правила
      </Typography>
      <Typography variant="body1" paragraph>
        {contest.description.split(/\r\n|\n/).map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
        ))}
      </Typography>
      {contest.intro_url && (
        <DiscussionsButton url={contest.intro_url}/>
      )}
    </Box>
  );
};

export default RulesView;
